import "./styles.scss";

import { faCircleUser, faCog, faSignOut, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, Outlet } from "react-router-dom";
import Brand from "../../components/Brand";
import { useCurrentUser } from "../../UserProvider";

export default function Main() {
  const { currentUser } = useCurrentUser();

  return (
    <div className="__main">
      <div className="root">
        <header className="header">
          <div className="header__container container">
            <div className="header__head">
              <Link to="/" className="header__brand brand">
                <Brand.Logo height={ 56 } className="brand__logo" />
              </Link>
              <div className="header__jobs">
                <Link to="/chat" className="button button--white button--link">
                  Ask Papaya
                </Link>
                <Link to="/jobs" className="button button--white button--link">
                  Jobs
                </Link>
              </div>
              { !currentUser && (
                <div className="header__button-group">
                  <Link to="/login" className="button button--white button--link">
                    Login
                  </Link>
                  <Link to="/signup" className="button button--white button--fill">
                    Sign Up
                  </Link>
                </div>
              ) }
              { currentUser && (
                <Dropdown align="end" className="dropdown">
                  <Dropdown.Toggle as="div" bsPrefix="custom-toggle" className="dropdown__toggle account">
                    <FontAwesomeIcon icon={faCircleUser} className="account__icon" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown__menu">
                    { currentUser.is_admin && (
                      <div className="dropdown__admin-menu">
                        <Dropdown.Item as={Link} to="/user-data" className="dropdown__item">
                          User Data
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/rss-feeds" className="dropdown__item">
                          RSS Feeds
                        </Dropdown.Item>
                      </div>
                    )}
                    <Dropdown.Item as={Link} to={`/a/${currentUser.display_name}`} className="dropdown__item">
                      <FontAwesomeIcon icon={faUser} /> Profile
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/account-settings" className="dropdown__item">
                      <FontAwesomeIcon icon={faCog} /> Account settings
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/logout" className="dropdown__item">
                      <FontAwesomeIcon icon={faSignOut} /> Sign out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) }
            </div>
          </div>
        </header>
        <main className="main">
          <Outlet />
        </main>
        <footer className="footer">
          <div className="footer__container container">
            <Link to="/" className="footer__brand brand">
              <Brand.Logo height={ 56 } className="brand__logo" />
            </Link>
            <nav className="footer__nav nav">
              <ul className="nav__list">
                <li className="nav__item">
                  <span className="item">
                    © { new Date().getFullYear() } Papaya
                  </span>
                </li>
                <li className="nav__item">
                  <a href="/privacy" rel="noopener noreferrer" target="_blank" className="item item__link">
                    Privacy Police
                  </a>
                </li>
                <li className="nav__item">
                  <a href="/terms" rel="noopener noreferrer" target="_blank" className="item item__link">
                    Terms and conditions
                  </a>
                </li>
                <li className="nav__item">
                  <a href={ `mailto:${ process.env.REACT_APP_CONTACT_EMAIL }` } className="item item__link">
                    Contact us
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </footer>
      </div>
    </div>
  )
}
